const state = {
  curCaseid: {},
  caseinfoPageId: {},
  cuiji: null, // 打电话还未做催记的案件id
}

const mutations = {
  SET_CUR_CASEID: (state, curCaseid) => {
    Object.assign(state.curCaseid, curCaseid)
  },
  SET_CASEINFO_PAGE_ID: (state, caseinfoPageId) => {
    state.caseinfoPageId = caseinfoPageId
  },
  SET_CUIJI: (state, cuiji) => {
    state.cuiji = cuiji
  },
}

const actions = {
  addCaseinfoId({ state, commit }, info) {
    // Object.assign(state.caseinfoPageId, info)
    commit('SET_CASEINFO_PAGE_ID', { ...state.caseinfoPageId, ...info })
  },

  delCaseinfoId({ state, commit }, id) {
    delete state.caseinfoPageId[id]
    commit('SET_CASEINFO_PAGE_ID', state.caseinfoPageId)
  },
  //添加来电催记记录
  addCuiji({ state, commit, dispatch, rootState }, case_id) {
    if (state.cuiji == null) {
      state.cuiji = [];
    }
    state.cuiji.push(case_id);
    commit('SET_CUIJI', state.cuiji)
    // 更新tagsView
    setTimeout(() => {
      let visitedViews = rootState.tagsView.visitedViews;
      for (let i = 0; i < visitedViews.length; i++) {
        if (visitedViews[i].path.indexOf('/CaseInfo') !== -1 && visitedViews[i].params.caseId == case_id) {
          Object.assign(visitedViews[i],{ cuiji: false })
        } else {
          Object.assign(visitedViews[i],{ cuiji: true })
        }
      }
      dispatch('tagsView/updateVisitedViewCuiji', visitedViews, { root: true })
    })
    
  },
  //删除来电催记记录
  delCuiji({ state, commit, dispatch, rootState }, case_id) {
    if (state.cuiji.length > 0) {
      const index = state.cuiji.indexOf(case_id);
      if (index > -1) {
        state.cuiji.splice(index, 1);
      }
    }
    commit('SET_CUIJI', state.cuiji)
    // 更新tagsView
    let visitedViews = rootState.tagsView.visitedViews;
    for (let i = 0; i < visitedViews.length; i++) {
      Object.assign(visitedViews[i],{ cuiji: false })
    }
    dispatch('tagsView/updateVisitedViewCuiji', visitedViews, { root: true })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/caseInfoPage.js